import { getConfig, getCurrentEnvironment } from '../config/environments.js';

/**
 * Returns the base URL for the donate portal based on the current environment.
 * 
 * @returns The base URL for the donate portal (e.g., 'https://donate.kuow.org')
 */
export function getDonatePortalBaseUrl(): string {
  const env = getCurrentEnvironment();
  
  switch (env) {
    case 'local':
      return 'http://localhost:5173';
    case 'development':
      return 'https://donate-dev.kuow.org';
    case 'staging':
      return 'https://donate-stage.kuow.org';
    case 'production':
      return 'https://donate.kuow.org';
    default:
      return 'https://donate.kuow.org';
  }
}

export function getMainWebsiteUrl(): string {
  return getConfig().mainSiteUrl;
}

/**
 * Returns the full URL for a donation form slug.
 * 
 * @param slug - The form slug (e.g., 'kuow-web')
 * @returns The full URL to the donation form (e.g., 'https://donate.kuow.org/donate/kuow-web')
 */
export function getDonationFormUrl(slug: string): string {
  const baseUrl = getDonatePortalBaseUrl();
  return `${baseUrl}/donate/${slug}`;
}

/**
 * Returns the URL prefix for donation form slugs (used in admin UI).
 * 
 * @returns The URL prefix (e.g., 'https://donate.kuow.org/donate/')
 */
export function getDonationFormUrlPrefix(): string {
  const baseUrl = getDonatePortalBaseUrl();
  return `${baseUrl}/donate/`;
}

const WIDGET_CDN_ENV_MAP: Record<string, string> = {
  local: 'dev',
  development: 'dev',
  staging: 'stage',
  production: 'production',
};

export function getWidgetCdnBaseUrl(): string {
  const env = getCurrentEnvironment();
  const cdnEnv = WIDGET_CDN_ENV_MAP[env] ?? 'dev';
  return `https://widgets.kuow.io/${cdnEnv}/latest`;
}

export function getMembersAreaUrl(): string {
  // for now, send to members area on main website
  return `${getMainWebsiteUrl()}/me`;
}

